
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ProjectService } from 'src/app/shared/services/project.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { UserPermissionAdminService } from 'src/app/shared/services/user-permission-admin.service';
import { AddModalComponent } from './add-modal/add-modal.component';
import { EditModalComponent } from './edit-modal/edit-modal.component';

@Component({
  selector: 'app-projectmanagement-page',
  imports: [FormsModule,
    ButtonModule,
    CardModule,
    TableModule
  ],
  templateUrl: './projectmanagement-page.component.html',
  styleUrl: './projectmanagement-page.component.scss'
})
export class ProjectmanagementPageComponent implements OnInit {

  constructor(
    protected projectService: ProjectService,
    protected permissionService: UserPermissionAdminService,
    protected rss: RouteShareService,
    private modalService: BsModalService
  ) { }

  public ngOnInit(): void {
    if (this.projectService.selectedProject) {
      this.permissionService.selectedProjectId = this.projectService.selectedProject._id;
    } else {
      this.permissionService.selectedProjectId = "";
    }
  }

  protected openAddModal(type: 'user' | 'group') {
    this.modalService.show(AddModalComponent, {
      class: 'modal-lg',
      initialState: {
        type
      }
    });
  }

  protected openEditModal(id: string) {
    this.permissionService.selectedGroupId = id;
    this.modalService.show(EditModalComponent, { class: 'modal-lg' });
  }

}
